import { css, RuleSet } from "styled-components";
import { Breakpoints, Prefixes, mediaQueriesGuard } from "@app/styles/variables/breakpoints";

// Iterate through the sizes and create a media template
const mediaQueries = (prefix = Prefixes.MinWidth) =>
    Object.keys(Breakpoints).reduce(
        (acc, k) => {
            const key = k as keyof typeof Breakpoints;
            const value = Breakpoints[key];
            if (typeof value !== "number") {
                return acc;
            }

            acc[key] = (literals: TemplateStringsArray, ...placeholders: any[]) => css`
                @media ${prefix === Prefixes.MaxWidth ? `(max-width: ${value - mediaQueriesGuard}px)` : `(min-width: ${value}px)`} {
                    ${css(literals, ...placeholders)}
                }
            `;
            return acc;
        },
        {} as Record<keyof typeof Breakpoints, (l: TemplateStringsArray, ...p: any[]) => RuleSet<object>>
    );

export const fromMedia = mediaQueries();
export const toMedia = mediaQueries(Prefixes.MaxWidth);
